/**
 * @generated SignedSource<<326995534030d0899458e6a733b6b5db>>
 * @relayHash 32878f9dba46f2895d84694c9d4a7420
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aacd295096a5f8c66b22631d164f26a6235408fcb1fae613fb205b249749c44b

import type { ConcreteRequest } from 'relay-runtime';
export type useConfluenceAutomationNudgeActionsQuery$variables = {
  contentId: string;
  isDraft: boolean;
  skipContentReviewerNudge: boolean;
  skipStatusUpdatesAutomation: boolean;
};
export type useConfluenceAutomationNudgeActionsQuery$data = {
  readonly singleContent: {
    readonly __typename: "Content";
    readonly ancestors?: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly children?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly metadata: {
          readonly createdDate: string | null;
        };
        readonly title: string | null;
      } | null> | null;
    } | null;
    readonly contentState?: {
      readonly id: string | null;
      readonly name: string;
    } | null;
    readonly history?: {
      readonly ownedBy: {
        readonly accountId?: string | null;
      } | null;
    } | null;
    readonly id: string | null;
    readonly metadata?: {
      readonly sourceTemplateEntityId: string | null;
    };
    readonly space?: {
      readonly id: string | null;
    } | null;
    readonly title?: string | null;
  } | null;
  readonly user: {
    readonly __typename: "AtlassianUser";
    readonly emails?: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
    readonly id: string | null;
  } | null;
};
export type useConfluenceAutomationNudgeActionsQuery = {
  response: useConfluenceAutomationNudgeActionsQuery$data;
  variables: useConfluenceAutomationNudgeActionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipContentReviewerNudge"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipStatusUpdatesAutomation"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "condition": "skipStatusUpdatesAutomation",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "AtlassianUserEmail",
          "kind": "LinkedField",
          "name": "emails",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "kind": "ScalarField",
              "name": "isPrimary"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v8 = {
  "condition": "skipContentReviewerNudge",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDraft",
          "variableName": "isDraft"
        }
      ],
      "concreteType": "ContentState",
      "kind": "LinkedField",
      "name": "contentState",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "title"
},
v10 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ]
},
v11 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v9/*: any*/)
  ]
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v13 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sourceTemplateEntityId"
    }
  ]
},
v14 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    }
  ],
  "concreteType": "PaginatedContentList",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": [
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v9/*: any*/),
        {
          "concreteType": "ContentMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "createdDate"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "children(first:25)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "selections": [
      (v6/*: any*/),
      {
        "args": (v7/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v8/*: any*/),
          {
            "condition": "skipStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/)
                    ]
                  }
                ]
              },
              (v13/*: any*/),
              (v14/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "selections": [
      (v6/*: any*/),
      {
        "args": (v7/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v8/*: any*/),
          {
            "condition": "skipStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v12/*: any*/)
                    ]
                  }
                ]
              },
              (v13/*: any*/),
              (v14/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "32878f9dba46f2895d84694c9d4a7420",
    "id": "aacd295096a5f8c66b22631d164f26a6235408fcb1fae613fb205b249749c44b",
    "metadata": {},
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "operationKind": "query",
    "text": "query useConfluenceAutomationNudgeActionsQuery($contentId:ID!,$skipStatusUpdatesAutomation:Boolean!,$skipContentReviewerNudge:Boolean!,$isDraft:Boolean!){user:confluence_atlassianUser(current:true){__typename,id,emails@skip(if:$skipStatusUpdatesAutomation){value,isPrimary}},singleContent(id:$contentId){__typename,id,contentState(isDraft:$isDraft)@skip(if:$skipContentReviewerNudge){id,name},title@skip(if:$skipStatusUpdatesAutomation)\n    space@skip(if:$skipStatusUpdatesAutomation){id}\n    ancestors@skip(if:$skipStatusUpdatesAutomation){id,title}\n    history@skip(if:$skipStatusUpdatesAutomation){ownedBy{__typename,...on KnownUser{accountId}}}\n    metadata@skip(if:$skipStatusUpdatesAutomation){sourceTemplateEntityId}\n    children(first:25)@skip(if:$skipStatusUpdatesAutomation){nodes{id,title,metadata{createdDate}}}}}"
  }
};
})();

(node as any).hash = "22fd54cb5708a9e9424a0c2f37ed9d47";

export default node;
